module.exports = __webpack_public_path__ + "img/4_132.a36ab962.png";